import { erpAxios } from '..';

const getLoanInfo = async (id) => {
  const { data } = await erpAxios.get(`/loan/getLoanInfo/${id}`);
  return data;
};

export default getLoanInfo;
